import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionArrangementType } from "../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { SubAccountType } from "../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { TransferType } from "../../../../../Wrap/Constants/Enums/Domain/TransferType";
import { InstrumentSelections } from "../../../../../Wrap/Models/Models/InstrumentSelection/InstrumentSelections";
import { ProcessType } from "../../Resource/Content";
import { AllocationTableItem } from "../../Store/SelectedInvesmentStoreStatic";
import { SubAccountTypeHelper } from "../../../../Dashboard/Components/Clients/Common/Helpers/SubAccountTypeHelper";
import { TransferISTSelection } from "../../../../../Wrap/Models/Models/InstrumentSelection/TransferISTSelection";
import { TransferBase } from "../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/TransferBase";
import { Instrument } from "../../../../../Wrap/Models/Domains/Investment/Instrument";

export const getISTPaymentAmount = (data, transferKey) => {
    if (!data) {return 0;}
    const keys = [
        "ClientSinglePayment",
        "ThirdPartySinglePayment",
        "EmployerSinglePayment",
        "ClientRegularPayment",
        "ThirdPartyRegularPayment",
        "EmployerRegularPayment",
    ];
    const total = keys.reduce((total, ele) => {
        return total + initAmount(data[ele]?.Money);
    }, 0);
    const transferInAmount = !data[transferKey]
        ? 0
        : data[transferKey].reduce((total, ele) => {
              return total + initAmount(ele.CurrentValue);
          }, 0);
    return total + transferInAmount;
};

export const getPaymentsAmountByKey = (data, key) => {
    if (!data) {return 0;}
    const keys = key;
    const total = keys.reduce((total, ele) => {
        return total + initAmount(data[ele]?.Money);
    }, 0);
    return total;
};

export const getTransferInAmount = (data, transferKey) => {
    if (!data) {return 0;}
    const transferInAmount = !data[transferKey]
        ? 0
        : (data[transferKey] || []).reduce((total, ele) => {
              return total + initAmount(ele.CurrentValue);
          }, 0);
    return transferInAmount;
};

export const getReRegTransferAmount = (data, transferKey) => {
    if (!data) {return 0;}
    const transferInAmount = !data[transferKey]
        ? 0
        : (data[transferKey] || []).reduce((total, ele) => {
              return (
                  total +
                  initAmount(ele.ReRegisterValue) +
                  (ele.Instruments || []).reduce((totalInstruments, item) => {
                      return totalInstruments + initAmount(item.QuotationValue);
                  }, 0)
              );
          }, 0);
    return transferInAmount;
};

export const getReRegInvestment = (data: TransferBase[], cashInstrument: Instrument): TransferISTSelection[] => {
    if (!data) {return [];}
    let result: TransferISTSelection[] = [];
    data.forEach((transfer) => {
        const instrument: TransferISTSelection[] = transfer?.Instruments || [];
        if (transfer?.["InvestmentsToBeTransferredInSpecie"] !== false && transfer?.ReRegisterValue?.Amount > 0) {
            instrument.concat({
                Investment: cashInstrument,
                Units: 1,
                QuotationValue: transfer?.ReRegisterValue,
            });
        }
        result = result.concat(instrument);
    });

    return result;
};

export const hasSinglePayments = (data) => {
    const keys = ["ClientSinglePayment", "ThirdPartySinglePayment", "EmployerSinglePayment"];
    return hasOneKindPayment(data, keys);
};

export const hasRegularPayments = (data) => {
    const keys = ["ClientRegularPayment", "ThirdPartyRegularPayment", "EmployerRegularPayment"];
    return hasOneKindPayment(data, keys);
};

export const hasThirdPartyRegularPayments = (data) => {
    const keys = ["ThirdPartyRegularPayment"];
    return hasOneKindPayment(data, keys);
};

export const hasEmployerRegularPayments = (data) => {
    const keys = ["EmployerRegularPayment"];
    return hasOneKindPayment(data, keys);
};

export const hasClientRegularPayments = (data) => {
    return hasOneKindPayment(data, ["ClientRegularPayment"]);
};

export const hasCashTransfer = (transfers: any[]) => {
    return (
        transfers &&
        transfers.length > 0 &&
        transfers.some(
            (ele) => ele.TransferType != TransferType.InSpecie || ele.InvestmentsToBeTransferredInSpecie == false
        )
    );
};

export const hasPostTransfer = (transfers: any[]) => {
    if (!transfers || transfers.length == 0) {return false;}
    return transfers.some(
        (ele) => ele.PensionSource == PensionArrangementType.Crystallised && ele.TransferType == TransferType.Cash
    );
};

export const hasPreTransfer = (transfers: any[]) => {
    if (!transfers || transfers.length == 0) {return false;}
    return transfers.some(
        (ele) => ele.PensionSource == PensionArrangementType.Accumulation && ele.TransferType == TransferType.Cash
    );
};

export const initInstrumentSelection = (data, allocation?): AllocationTableItem => {
    return {
        Instrument: data,
        Single: initWeighting(allocation),
        ClientRegular: initWeighting(allocation),
        ThirdPartyRegular: initWeighting(allocation),
        EmployerRegular: initWeighting(allocation),
        Transfer: initWeighting(allocation),
        PostTransfer: initWeighting(allocation),
        allocation: null,
    };
};

export const allocationColShowCondition = (process: ProcessType) => {
    return ![
        ProcessType.Buy,
        ProcessType.Sell,
        ProcessType.SwitchFrom,
        ProcessType.SwitchTo,
        ProcessType.NB,
        ProcessType.SinglePayment,
        ProcessType.TopUpWithITFLS,
        ProcessType.Quote,
        ProcessType.AddRegular,
        ProcessType.EditRegular,
        ProcessType.WhatIf,
    ].includes(process);
};

export const onlySingleColShowConditon = (process: ProcessType, product: SubAccountType, data) => {
    return (
        [
            ProcessType.NB,
            ProcessType.SinglePayment,
            ProcessType.TopUpWithITFLS,
            ProcessType.Quote,
            ProcessType.WhatIf,
        ].includes(process) &&
        hasSinglePayments(data) &&
        !hasCashTransfers(product, data) &&
        !hasPreTransfer(data?.PensionTransfers)
    );
};

export const onlyClientRegularColShowConditon = (process: ProcessType, data) => {
    return (
        [
            ProcessType.NB,
            ProcessType.Quote,
            ProcessType.AddRegular,
            ProcessType.EditRegular,
            ProcessType.WhatIf,
        ].includes(process) && hasClientRegularPayments(data)
    );
};
export const onlyThirdPartyRegularColShowConditon = (process: ProcessType, data) => {
    return (
        [
            ProcessType.NB,
            ProcessType.Quote,
            ProcessType.AddRegular,
            ProcessType.EditRegular,
            ProcessType.WhatIf,
        ].includes(process) && hasThirdPartyRegularPayments(data)
    );
};
export const onlyEmployerRegularColShowConditon = (process: ProcessType, data) => {
    return (
        [
            ProcessType.NB,
            ProcessType.Quote,
            ProcessType.AddRegular,
            ProcessType.EditRegular,
            ProcessType.WhatIf,
        ].includes(process) && hasEmployerRegularPayments(data)
    );
};

export const hasCashTransfers = (product: SubAccountType, data) => {
    if (SubAccountTypeHelper.isOnPlatformPension(product)) {return false;}
    const key = product == SubAccountType.StocksIsa ? "IsaTransfers" : "GiaTransfers";
    return (
        data[key] &&
        data[key].filter(
            (ele) => ele.TransferType !== TransferType.InSpecie || ele.InvestmentsToBeTransferredInSpecie == false
        ).length > 0
    );
};

export const onlyTransferColShowConditon = (process: ProcessType, product: SubAccountType, data) => {
    if (SubAccountTypeHelper.isOnPlatformPension(product)) {return false;}
    return (
        [
            ProcessType.NB,
            ProcessType.SinglePayment,
            ProcessType.TopUpWithITFLS,
            ProcessType.Quote,
            ProcessType.WhatIf,
        ].includes(process) &&
        !hasSinglePayments(data) &&
        hasCashTransfers(product, data)
    );
};

export const singleAndCashTransferColShowConditon = (process: ProcessType, product: SubAccountType, data) => {
    return (
        [
            ProcessType.NB,
            ProcessType.SinglePayment,
            ProcessType.TopUpWithITFLS,
            ProcessType.Quote,
            ProcessType.WhatIf,
        ].includes(process) &&
        hasSinglePayments(data) &&
        (hasCashTransfers(product, data) || hasPreTransfer(data?.PensionTransfers))
    );
};

export const preRetirementTransferColShowCondition = (process: ProcessType, product: SubAccountType, data) => {
    if (!SubAccountTypeHelper.isOnPlatformPension(product) || !data || !data.PensionTransfers) {return false;}
    return (
        [
            ProcessType.NB,
            ProcessType.SinglePayment,
            ProcessType.TopUpWithITFLS,
            ProcessType.Quote,
            ProcessType.WhatIf,
        ].includes(process) &&
        !hasSinglePayments(data) &&
        hasPreTransfer(data.PensionTransfers)
    );
};

export const postRetirementTransferColShowCondition = (process: ProcessType, product: SubAccountType, data) => {
    if (!SubAccountTypeHelper.isOnPlatformPension(product) || !data || !data.PensionTransfers) {return false;}
    return (
        [
            ProcessType.NB,
            ProcessType.SinglePayment,
            ProcessType.TopUpWithITFLS,
            ProcessType.Quote,
            ProcessType.WhatIf,
        ].includes(process) && hasPostTransfer(data.PensionTransfers)
    );
};

export const pensionInstrumentSelectionToInstrumentSelection = (
    preRetirementInstrumentSelections,
    postRetirementInstrumentSelections,
    cashInstrument
): InstrumentSelections => {
    if (!preRetirementInstrumentSelections || preRetirementInstrumentSelections.length == 0)
        {return { Instruments: [{ ...initInstrumentSelection(cashInstrument) }] };}
    const data = initPensionInstrumentSelections(
        preRetirementInstrumentSelections.Instruments,
        postRetirementInstrumentSelections.Instruments
    );
    const instruments = data?.map((ele) => {
        return {
            Instrument: ele.Instrument,
            Single: ele.Single,
            Regular: ele.Regular,
            Transfer: {
                Money: {
                    Amount: (ele.Transfer?.Money?.Amount || 0) + (ele.PostTransfer?.Money?.Amount || 0),
                    Currency: CurrencyCode.GBP,
                },
                Percentage: (ele.Transfer?.Percentage || 0) + (ele.PostTransfer?.Percentage || 0),
            },
        };
    });
    return { Instruments: instruments };
};

export const initPensionInstrumentSelections = (preRetirement, postRetirement) => {
    const totalInstrument = [];
    preRetirement.concat(postRetirement).forEach((element) => {
        if (!totalInstrument.find((item) => item.Instrument.ProductId == element.Instrument.ProductId)) {
            totalInstrument.push(element);
        }
    });
    return totalInstrument.map((ele) => {
        const preIndex = preRetirement.findIndex((item) => ele.Instrument.ProductId == item.Instrument.ProductId);
        const postIndex = postRetirement.findIndex((item) => ele.Instrument.ProductId == item.Instrument.ProductId);
        return {
            Instrument: ele.Instrument,
            Single: preIndex > -1 ? preRetirement[preIndex].Single : initWeighting(),
            Regular: preIndex > -1 ? preRetirement[preIndex].Regular : initWeighting(),
            Transfer: preIndex > -1 ? preRetirement[preIndex].Transfer : initWeighting(),
            PostTransfer: postIndex > -1 ? postRetirement[postIndex].Transfer : initWeighting(),
            underlying: ele.underlying,
            isToggle: ele.isToggle,
            needToggle: ele.needToggle,
            isPortfolio: ele.isPortfolio,
            modelPortfolioType: ele.modelPortfolioType,
            isTargetAllocation: ele.isTargetAllocation,
        };
    });
};

export const initWeighting = (allocation?) => {
    return { Money: initMoney(), Percentage: allocation || null };
};

const initMoney = () => {
    return { Amount: null, Currency: CurrencyCode.GBP };
};

const hasOneKindPayment = (data, keys: string[]) => {
    if (data)
        {if (data.Contribution) {
            return keys.map((ele) => hasPayment(data.Contribution[ele])).includes(true);
        } else {
            return keys.map((ele) => hasPayment(data[ele])).includes(true);
        }}
};

const hasPayment = (data): boolean => {
    return !CommonHelper.isNullOrEmpty(data && data.Money && data.Money.Amount);
};

export const initAmount = (money) => {
    if (!money || !money.Amount) {return 0;}
    return money.Amount;
};
